import { atom, useRecoilState } from "recoil";

export const User = atom({
  key: "User",
  default: {
    token: "",
    name: "",
    role: "",
    hasCompletedProfile: false,
    isVerified: false,
    picture: "",
  },
});

export const useUserInfo = () => {
  const [user, setUser] = useRecoilState(User);
  return { user, setUser };
};
